// @flow

import React from 'react'
import { Route } from 'react-router-dom'
import { AnimatedSwitchPagination, SimpleLayout } from './async-loading'
import clientData from 'utils/client-data'

import DummyTempComponent from './screens/seller/'
import OnBoardingDetails from './screens/seller/details'
import Social from './screens/seller/social'

const overpanelViews = [
  'landing',
  'details',
  'social',
  'photos',
  'preview',
  'success',
  'dashboard',
  'dashboard/preview',
  'settings',
  'error',
]

export default () => {
  return (
    <Route exact path={`/seller/(${overpanelViews.join('|')})`}>
      <SimpleLayout>
        <AnimatedSwitchPagination>
          {/*
           * Landing Page - (Carousel) - /seller/landing
           * Onboarding Step 1 - /seller/details
           * Onboarding Step 2 - /seller/social
           * Photo upload - /seller/photos
           * Cover photo upload - (reuse from personal) - /my/cover/select
           * Onboarding Preview - /seller/preview
           * Onboarding Success - /seller/success
           */}
          <SellerRoute
            exact
            path="/seller/landing"
            component={DummyTempComponent}
          />
          <SellerRoute
            exact
            path="/seller/details"
            component={OnBoardingDetails}
          />
          <SellerRoute exact path="/seller/social" component={Social} />
          <SellerRoute
            exact
            path="/seller/photos"
            component={DummyTempComponent}
          />
          <SellerRoute
            exact
            path="/seller/preview"
            component={DummyTempComponent}
          />
          <SellerRoute
            exact
            path="/seller/success"
            component={DummyTempComponent}
          />
          {/*
           * Dashboard - (Seller Profile Management) -  /seller/dashboard
           * Dashboard -> Preview (Preview what public will see) - /seller/dashboard/preview
           * Dashboard -> Edit ( Edit settings/details ) - /seller/settings
           */}
          <SellerRoute
            exact
            path="/seller/dashboard"
            component={DummyTempComponent}
          />
          <SellerRoute
            exact
            path="/seller/dashboard/preview"
            component={DummyTempComponent}
          />
          <SellerRoute
            exact
            path="/seller/settings"
            component={DummyTempComponent}
          />
        </AnimatedSwitchPagination>
      </SimpleLayout>
    </Route>
  )
}

type ReactComponent = () => React.Element | React.Component

function SellerRoute({ component: Comp }: { component: ReactComponent }) {
  return (
    <Route
      exact
      render={routerProps => (
        <Comp
          {...routerProps}
          // add more stuff here as needed
          merchantCategoryCodesList={clientData.merchantCategoryCodesList}
        />
      )}
    />
  )
}
